export const cities = [
  {
    slug: 'miami',
    name: 'Miami',
    lat: 25.7617,
    lng: -80.1918,
    luxury: false,
    intro: "From high-rise condos in Brickell to family homes in Coral Gables and Coconut Grove, we repair appliances across the entire Miami area. Condo buildings often have compact, European-style appliances — we service those too, and we coordinate with building management for service elevator access when needed.",
    neighborhoods: ['Brickell', 'Coconut Grove', 'Coral Gables', 'Wynwood', 'Little Havana', 'Key Biscayne', 'Midtown', 'Edgewater'],
    services: ['Refrigerator & freezer repair', 'Washer & dryer repair (including stacked condo units)', 'Dishwasher repair', 'Oven, cooktop & microwave repair', 'Wine cooler & ice maker repair', 'Marine & yacht galley appliances'],
    testimonial: {
      name: 'Carlos M.',
      area: 'Brickell',
      appliance: 'LG Refrigerator',
      text: "Our fridge died in our Brickell condo on a Saturday. He handled the building's service elevator rules, showed up the same day, and had it cooling again in under two hours."
    }
  },
  {
    slug: 'fort-lauderdale',
    name: 'Fort Lauderdale',
    path: '/appliance-repair-fort-lauderdale-fl',
    hub: true,
    microAreas: ['Las Olas', 'Lauderdale-by-the-Sea', 'Dania Beach'],
    lat: 26.1224,
    lng: -80.1373,
    luxury: true,
    luxuryNote: "Fort Lauderdale homes — from Las Olas Isles waterfront estates to Coral Ridge — often feature Sub-Zero, Wolf, Miele and Thermador appliances. We are experienced with high-end built-in units and panel-ready installations. As the Yachting Capital of the World, Fort Lauderdale also keeps us busy with marine refrigerators, galley appliances, wine coolers and ice makers aboard vessels along the New River and Intracoastal — from Bahia Mar to Pier Sixty-Six. We also serve commercial restaurant kitchens and upscale residential homes throughout the area.",
    neighborhoods: ['Las Olas Isles', 'Victoria Park', 'Coral Ridge', 'Harbor Beach', 'Rio Vista', 'Wilton Manors', 'Imperial Point'],
    services: ['Sub-Zero & Wolf repair', 'Refrigerator & wine cooler repair', 'Washer & dryer repair', 'Dishwasher repair', 'Oven & cooktop repair', 'Yacht & marine appliance repair'],
    testimonial: {
      name: 'Susan K.',
      area: 'Harbor Beach',
      appliance: 'Sub-Zero Wine Cooler',
      text: "He repaired the Sub-Zero wine cooler on our boat docked near Bahia Mar. Knew exactly what he was doing with marine units — hard to find that expertise. Fair price, same week service."
    }
  },
  {
    slug: 'pompano-beach',
    name: 'Pompano Beach',
    path: '/appliance-repair-pompano-beach-fl',
    hub: true,
    microAreas: ['Lighthouse Point', 'Deerfield Beach', 'Hillsboro Beach'],
    lat: 26.2379,
    lng: -80.1248,
    luxury: false,
    intro: "Pompano Beach is our northward growth corridor — we serve waterfront single-family homes, Palm Aire condos, commercial accounts and the affluent boating communities of Lighthouse Point and Hillsboro Beach. Salt air near the beach is tough on appliances; we regularly handle corrosion-related failures on refrigerators and washers in oceanfront buildings, and we service marine and galley appliances for the waterfront homes along the canals.",
    neighborhoods: ['Palm Aire', 'Cresthaven', 'Garden Isles', 'Santa Barbara Shores', 'Cypress Bend', 'Harbor Village'],
    services: ['Refrigerator & freezer repair', 'Washer & dryer repair', 'Dishwasher repair', 'Oven, cooktop & microwave repair', 'Ice maker repair'],
    testimonial: {
      name: 'Mike D.',
      area: 'Palm Aire',
      appliance: 'Samsung Dryer',
      text: "Dryer stopped heating. He diagnosed it over the phone before even coming out, brought the right part, and fixed it in one visit. Honest and fast."
    }
  },
  {
    slug: 'deerfield-beach',
    name: 'Deerfield Beach',
    lat: 26.3184,
    lng: -80.0998,
    luxury: false,
    intro: "From Deer Creek and Crystal Lake to The Cove and Century Village East, we provide same-day appliance repair throughout Deerfield Beach. We're familiar with the older appliance models common in Century Village and always give an honest repair-or-replace recommendation.",
    neighborhoods: ['Deer Creek', 'The Cove', 'Century Village East', 'Crystal Lake', 'Starlight Cove'],
    services: ['Refrigerator & freezer repair', 'Washer & dryer repair', 'Dishwasher repair', 'Oven & cooktop repair', 'Microwave repair'],
    testimonial: {
      name: 'Arlene S.',
      area: 'Century Village East',
      appliance: 'GE Oven',
      text: "My oven wouldn't hold temperature before a family dinner. He came the same afternoon, replaced the sensor, and charged exactly what he quoted. A gentleman and a professional."
    }
  },
  {
    slug: 'davie',
    name: 'Davie',
    lat: 26.0765,
    lng: -80.2521,
    luxury: false,
    intro: "We cover all of Davie — from Pine Island Ridge and Shenandoah to the larger ranch properties in Long Lake Ranches. Bigger homes often mean second refrigerators, garage freezers and heavy-use laundry — we repair them all.",
    neighborhoods: ['Pine Island Ridge', 'Shenandoah', 'Long Lake Ranches', 'Forest Ridge', 'Riverstone', 'Imagination Farms'],
    services: ['Refrigerator, freezer & second-fridge repair', 'Washer & dryer repair', 'Dishwasher repair', 'Oven, cooktop & microwave repair', 'Ice maker repair'],
    testimonial: {
      name: 'Robert T.',
      area: 'Long Lake Ranches',
      appliance: 'Maytag Washer',
      text: "With five kids, our washer runs non-stop and it finally quit. He came out next morning, replaced the drive belt and pump, and it's been perfect since. Great warranty too."
    }
  },
  {
    slug: 'hollywood',
    name: 'Hollywood',
    lat: 26.0112,
    lng: -80.1495,
    luxury: false,
    intro: "From historic Hollywood Lakes homes to Emerald Hills and the beachside condos along the Broadwalk, we repair appliances across all of Hollywood, FL. Older character homes often have appliance configurations that need extra care — we treat them right.",
    neighborhoods: ['Hollywood Lakes', 'Emerald Hills', 'Hollywood Hills', 'Royal Poinciana', 'West Lake Village', 'Hollywood Beach'],
    services: ['Refrigerator & freezer repair', 'Washer & dryer repair', 'Dishwasher repair', 'Oven, cooktop & microwave repair', 'Wine cooler repair'],
    testimonial: {
      name: 'Daniela F.',
      area: 'Hollywood Lakes',
      appliance: 'Bosch Dishwasher',
      text: "Our Bosch dishwasher was leaking onto the wood floor. He found a cracked hose in minutes, had it repaired the same visit, and even checked the door seal at no charge."
    }
  },
  {
    slug: 'hallandale-beach',
    name: 'Hallandale Beach',
    lat: 25.9812,
    lng: -80.1484,
    luxury: false,
    intro: "We serve the condo towers and gated communities of Hallandale Beach — Golden Isles, Three Islands, Atlantic Shores and the beachfront high-rises. We coordinate with concierge and building management, and we're experienced with the compact and European appliances common in tower residences.",
    neighborhoods: ['Golden Isles', 'Three Islands', 'Atlantic Shores', 'Beach Club towers', 'Gulfstream Park area'],
    services: ['Refrigerator & freezer repair', 'Compact & stacked washer-dryer repair', 'Dishwasher repair', 'Cooktop & oven repair', 'Wine cooler & ice maker repair'],
    testimonial: {
      name: 'Irina V.',
      area: 'Three Islands',
      appliance: 'Induction Cooktop',
      text: "The induction cooktop in our condo stopped working. Two companies refused high-rise jobs — he came the next day, dealt with the building office himself, and fixed it."
    }
  },
  {
    slug: 'boynton-beach',
    name: 'Boynton Beach',
    lat: 26.5318,
    lng: -80.0905,
    luxury: false,
    intro: "Boynton Beach is the northern edge of our service area and we treat it like home turf — Hunters Run, Aberdeen, Canyon Lakes and the communities around Renaissance Commons. Same-day slots are available most days.",
    neighborhoods: ['Hunters Run', 'Aberdeen', 'Canyon Lakes', 'Renaissance Commons area', 'Valencia communities', 'Ocean Ridge'],
    services: ['Refrigerator & freezer repair', 'Washer & dryer repair', 'Dishwasher repair', 'Oven, cooktop & microwave repair', 'Ice maker repair'],
    testimonial: {
      name: 'Paul W.',
      area: 'Hunters Run',
      appliance: 'Whirlpool Refrigerator',
      text: "Fridge warm, freezer full of food. Called at 8 AM, he was here by noon, replaced the compressor relay, and saved everything. The $80 service call went toward the repair as promised."
    }
  },
  {
    slug: 'boca-raton',
    name: 'Boca Raton',
    path: '/appliance-repair-boca-raton-fl',
    hub: true,
    microAreas: ['Delray Beach', 'Highland Beach'],
    lat: 26.3683,
    lng: -80.1289,
    luxury: true,
    luxuryNote: "Boca Raton kitchens are among the finest in South Florida — gated country club communities like Royal Palm Yacht & Country Club, Boca West, Broken Sound and The Sanctuary commonly feature Sub-Zero refrigeration (often dual units), Wolf pro-ranges, Miele dishwashers, Gaggenau built-ins and full outdoor kitchens. We specialize in these high-end brands: factory-style diagnostics, careful handling of panel-ready and built-in units, outdoor kitchen appliance repair, and honest guidance on repairs worth making on premium equipment.",
    neighborhoods: ['Royal Palm Yacht & Country Club', 'Mizner Park area', 'Boca West', 'Broken Sound', 'The Sanctuary', 'Woodfield Country Club'],
    services: ['Sub-Zero & Wolf repair', 'Miele & Gaggenau repair', 'Built-in & panel-ready refrigeration', 'Wine cooler & ice maker repair', 'Washer & dryer repair', 'Oven & cooktop repair'],
    testimonial: {
      name: 'Linda H.',
      area: 'Broken Sound',
      appliance: 'Wolf Range',
      text: "Our Wolf range igniter failed before a holiday dinner. He sourced the genuine part, repaired it the same week, and the burners light perfectly. You can tell he knows luxury appliances."
    }
  },
  {
    slug: 'delray-beach',
    name: 'Delray Beach',
    lat: 26.4615,
    lng: -80.0728,
    luxury: true,
    luxuryNote: "From estates near the Seagate and Lake Ida to the condos off Atlantic Avenue, Delray Beach homes frequently feature Miele, Sub-Zero, Wolf and Thermador appliances. We provide specialist repair for these premium brands — proper diagnostics, genuine-quality parts, and respect for your home.",
    neighborhoods: ['Lake Ida', 'Seagate', 'Tropic Isle', 'Atlantic Avenue corridor', 'Delray Dunes', 'Addison Reserve area'],
    services: ['Miele & Sub-Zero repair', 'Wolf & Thermador repair', 'Refrigerator & wine cooler repair', 'Dishwasher repair', 'Washer & dryer repair', 'Oven & cooktop repair'],
    testimonial: {
      name: 'Mark B.',
      area: 'Lake Ida',
      appliance: 'Miele Dishwasher',
      text: "Our Miele dishwasher threw an error code nobody could figure out. He diagnosed a failed circulation pump, replaced it, and it runs silent again. Worth every penny."
    }
  },
  {
    slug: 'coral-gables',
    name: 'Coral Gables',
    path: '/appliance-repair-coral-gables-fl',
    hub: true,
    microAreas: ['Coconut Grove', 'Pinecrest', 'South Miami'],
    lat: 25.7215,
    lng: -80.2684,
    luxury: true,
    luxuryNote: "Coral Gables' historic estates — from Old Cutler Road to Cocoplum and Gables Estates — hold some of the finest kitchens in Miami-Dade: Sub-Zero refrigeration, Wolf ranges, built-in wine storage and panel-ready integrated appliances. We understand the care these homes require: protecting original cabinetry and millwork, servicing older built-in units that must be repaired rather than replaced, and working discreetly in private residences. We also cover Coconut Grove, Pinecrest and South Miami.",
    neighborhoods: ['Old Cutler Road corridor', 'Gables Estates', 'Cocoplum', 'Riviera', 'Snapper Creek', 'Gables by the Sea'],
    services: ['Sub-Zero & Wolf repair', 'Built-in wine storage & wine cellar refrigeration', 'Panel-ready & integrated appliance repair', 'Miele & Gaggenau repair', 'Washer & dryer repair', 'Oven, range & cooktop repair'],
    testimonial: {
      name: 'Gabriela R.',
      area: 'Cocoplum',
      appliance: 'Sub-Zero Wine Storage',
      text: "Our built-in Sub-Zero wine unit stopped holding temperature with a full collection inside. He came the same day, sourced the part quickly, and treated our home with complete respect. True professional."
    }
  },
  {
    slug: 'brickell-downtown-miami',
    name: 'Brickell & Downtown Miami',
    path: '/appliance-repair-brickell-downtown-miami',
    hub: true,
    microAreas: ['Edgewater', 'Midtown', 'Wynwood'],
    lat: 25.765,
    lng: -80.1936,
    luxury: true,
    luxuryNote: "Brickell and Downtown Miami's luxury towers are filled with integrated European appliances — Miele and Bosch dishwashers, panel-ready refrigerators, induction cooktops and under-counter wine coolers. We service them all, and we work with luxury rental property managers who need fast, reliable turnarounds between tenants. We handle building requirements ourselves: COIs, service elevator scheduling and front-desk coordination. Also covering Edgewater, Midtown and Wynwood.",
    neighborhoods: ['Brickell Key', 'Mary Brickell Village', 'Downtown Miami', 'Park West', 'Brickell Avenue corridor'],
    services: ['Miele & Bosch integrated appliance repair', 'Induction cooktop repair', 'Wine cooler & under-counter refrigeration', 'Stacked & compact washer-dryer repair', 'Panel-ready refrigerator repair', 'Property management & multi-unit service'],
    testimonial: {
      name: 'Andres L.',
      area: 'Brickell Key',
      appliance: 'Bosch Induction Cooktop',
      text: "I manage 12 rental units in Brickell and he's my go-to for every appliance issue. Handles the building paperwork, shows up when he says, and bills clean. This time: a Bosch induction cooktop fixed in one visit."
    }
  },
  {
    slug: 'miami-beach',
    name: 'Miami Beach',
    path: '/appliance-repair-miami-beach-fl',
    hub: true,
    microAreas: ['South Beach', 'Bal Harbour', 'Surfside', 'Sunny Isles Beach'],
    lat: 25.7907,
    lng: -80.13,
    luxury: true,
    luxuryNote: "Miami Beach runs on fast turnarounds — waterfront estates on the Venetian Islands, condo towers from South of Fifth to North Beach, and luxury vacation rentals that can't wait days for a repair before the next guest checks in. We offer rapid same-day response across the beach, service high-end brands like Sub-Zero, Wolf and Miele common in waterfront homes, and handle the salt-air corrosion issues unique to oceanfront buildings. Also covering South Beach, Bal Harbour, Surfside and Sunny Isles Beach.",
    neighborhoods: ['South of Fifth', 'Venetian Islands', 'Mid-Beach', 'North Beach', 'La Gorce', 'Normandy Isles'],
    services: ['Same-day vacation rental appliance repair', 'Sub-Zero, Wolf & Miele repair', 'Refrigerator & wine cooler repair', 'Washer & dryer repair', 'Dishwasher repair', 'Oven & cooktop repair'],
    testimonial: {
      name: 'Jessica T.',
      area: 'South of Fifth',
      appliance: 'LG Refrigerator',
      text: "The fridge in our vacation rental died with guests arriving the next morning. He answered at 8 AM, was there by 11, and had it running before check-in. Saved our booking and our reviews."
    }
  }
];

export const cityPath = (c) => c.path || `/appliance-repair/${c.slug}`;

export const serviceAreaDirectory = [
  {
    county: 'Miami-Dade County',
    tagline: 'Luxury Core & High-Rise Hubs',
    areas: [
      { name: 'Coral Gables', path: '/appliance-repair-coral-gables-fl' },
      { name: 'Brickell', path: '/appliance-repair-brickell-downtown-miami' },
      { name: 'Downtown Miami', path: '/appliance-repair-brickell-downtown-miami' },
      { name: 'Coconut Grove', path: '/appliance-repair-coral-gables-fl' },
      { name: 'Pinecrest', path: '/appliance-repair-coral-gables-fl' },
      { name: 'Miami Beach / South Beach', path: '/appliance-repair-miami-beach-fl' },
      { name: 'Bal Harbour', path: '/appliance-repair-miami-beach-fl' },
      { name: 'Sunny Isles Beach', path: '/appliance-repair-miami-beach-fl' },
      { name: 'Aventura', path: '/appliance-repair-miami-beach-fl' },
      { name: 'Key Biscayne', path: '/appliance-repair/miami' }
    ]
  },
  {
    county: 'Broward County',
    tagline: 'Expansion & Marine Corridor',
    areas: [
      { name: 'Fort Lauderdale (Las Olas / Harbor Beach)', path: '/appliance-repair-fort-lauderdale-fl' },
      { name: 'Pompano Beach', path: '/appliance-repair-pompano-beach-fl' },
      { name: 'Lighthouse Point', path: '/appliance-repair-pompano-beach-fl' },
      { name: 'Hollywood', path: '/appliance-repair/hollywood' },
      { name: 'Hallandale Beach', path: '/appliance-repair/hallandale-beach' },
      { name: 'Deerfield Beach', path: '/appliance-repair/deerfield-beach' },
      { name: 'Davie / Weston', path: '/appliance-repair/davie' }
    ]
  },
  {
    county: 'Palm Beach County',
    tagline: 'Northern Luxury Boundary',
    areas: [
      { name: 'Boca Raton', path: '/appliance-repair-boca-raton-fl' },
      { name: 'Highland Beach', path: '/appliance-repair-boca-raton-fl' },
      { name: 'Delray Beach', path: '/appliance-repair/delray-beach' },
      { name: 'Boynton Beach', path: '/appliance-repair/boynton-beach' }
    ]
  }
];
